import { AutocompleteOption } from 'app/agriculture/forms/components/Autocomplete/Autocomplete';
import { AssetIcon } from 'app/agriculture/icons/components';
import { useGenericEntities } from 'app/agriculture/queries/entities/useGenericEntities';
import { allEntityTypes, EntityType } from 'app/agriculture/models/Entities';
import { useMemo } from 'react';

export function useAttachOptions(entityTypes: EntityType[] = allEntityTypes): AutocompleteOption[] {
    const genericEntities = useGenericEntities(entityTypes);

    return useMemo(
        () =>
            Array.from(genericEntities)
                .map(([id, { name, type }]) => ({
                    id,
                    name: name ?? '',
                    icon: <AssetIcon name={type} />,
                }))
                .sort((a, b) => a.name.localeCompare(b.name)),
        [genericEntities],
    );
}
